<div class="min-h-full max-h-full w-full overflow-y-scroll scroll-hidden pt-4 pb-4">
    <div echarts #salesByCampaignTypeChart class="w-full h-72"></div>
    <div echarts #completionsByCampaignTypeChart class="w-full h-72 my-4"></div>
    <div echarts #profitByCampaignType class="w-full h-[500px] my-4"></div>
</div>